export const researchTracks = [
  {
    id: 1,
    title: "Medical AI & Clinical Decision Support",
    titleKo: "의료 AI 및 임상 의사 결정 지원",
    description: "AI-driven healthcare diagnostics and decision support systems for clinical data analysis and disease prediction",
    descriptionKo: "임상 데이터 분석 및 질병 예측을 위한 AI 기반 헬스케어 진단 및 의사 결정 지원 시스템",
    icon: "🏥",
    color: "from-blue-500 to-cyan-500",
    bgGradient: "from-blue-50 to-cyan-50",
    papers: [
      {
        id: 1,
        title: "고지혈증 진단의 기계학습 정확도 개선을 위한 중요 임상데이터 특징 선택",
        titleEn: "Important Clinical Data Feature Selection for Improving Machine Learning Accuracy in Hyperlipidemia Diagnosis",
        year: 2021,
        authors: "Seonmin Lee, Mintai Kim et al",
        journal: "한국통신학회 학술대회논문집",
        summary: "고지혈증 진단의 정확도를 개선하기 위해 임상 데이터의 중요한 특징을 선택하는 방법을 제안합니다.",
        keyPoints: [
          "25가지 임상 데이터 특징 중 10가지 중요 특징 선별",
          "MSE를 통한 특징 분포 차이 분석으로 우선순위 부여",
          "SVM, Decision Tree, Random Forest 적용하여 최대 13.3% 정확도 개선",
          "총 148명의 여성 고지혈증 임상 데이터(49~72세) 사용"
        ],
        methodology: "임상적으로 정의된 정상 범위와의 관계성과 환자/비환자 간 특징 분포 차이(MSE)를 기준으로 중요 특징 선택",
        results: "10가지 중요 특징 사용 시 25가지 특징 대비 최대 13.3% 정확도 개선 (SVM), Decision Tree가 73.3%로 최고 정확도",
        pdfFile: "고지혈증 진단의 기계학습 정확도 개선을 위한 중요 임상데이터 특징 선택.pdf"
      },
      {
        id: 2,
        title: "이상지질혈증 연관 인자를 활용한 얕은 학습 기반 HDL-콜레스테롤 예측",
        titleEn: "HDL-Cholesterol Prediction Using Shallow Learning with Dyslipidemia-Related Factors",
        year: 2021,
        authors: "Su-bhin Yang, Mintai Kim et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "혈액 채집을 요구하지 않는 인자들을 활용하여 HDL-콜레스테롤을 예측하는 얕은 학습 기반 MLP 모델을 설계합니다.",
        keyPoints: [
          "12가지 연관 인자 특징(AGE, SEX, BMI, PSQI, Muscle, Fat 등) 활용",
          "HDL 수준별(낮음<40, 보통40-60, 높음≥60) 특징 분포 유사성 분석",
          "분포 유사성이 낮은 특징일수록 HDL 예측에 중요",
          "혈액 수집 불필요한 비침습적 예측 방법"
        ],
        methodology: "얕은 학습 기반 MLP를 사용하여 HDL 수준별 특징 분포 차이를 분석하고 중요 특징 선택",
        results: "중요 특징 선택 시(하위 2개 제외) 70.8% 정확도로, 전체 특징 사용(65.3%) 대비 5.5% 개선",
        pdfFile: "이상지질혈증 연관 인자를 활용한 얕은 학습 기반 HDL-콜레스테롤 예측.pdf"
      },
      {
        id: 3,
        title: "준지도학습 기반 LDL-콜레스테롤 예측의 정확도 개선",
        titleEn: "Improving LDL-Cholesterol Prediction Accuracy Using Semi-Supervised Learning",
        year: 2022,
        authors: "Su-Bhin Yang, Mintai Kim et al",
        journal: "한국정보처리학회 학술대회논문집",
        summary: "준지도학습 기반 기계 학습 방법을 적용하여 LDL-콜레스테롤 예측 정확도를 개선합니다.",
        keyPoints: [
          "신체 계측 정보(X)로 HDL, TG, TC 예측 후 LDL 예측에 활용",
          "이상지질혈증 진단 인자 간 상관관계 활용한 준지도학습",
          "얕은 학습 기반 MLP 네트워크 사용",
          "452개 임상 데이터로 학습 및 검증"
        ],
        methodology: "신체 계측 정보로 혈액 계측 정보(HDL, TG, TC)를 순차적으로 예측하고, 이를 다시 입력 특징에 추가하여 LDL 예측",
        results: "혈액 예측 정보 활용 시 71.4% 정확도로, 신체 계측 정보만 사용(67.0%) 대비 4.4% 개선",
        pdfFile: "준지도학습 기반 LDL-콜레스테롤 예측의 정확도 개선.pdf"
      },
      {
        id: 4,
        title: "딥러닝 기반 의료 설문 결측 데이터 보간",
        titleEn: "Deep Learning-Based Interpolation of Missing Data in Medical Surveys",
        year: 2020,
        authors: "Seonmin Lee, Donguk Kim, Taehyeon Lee, Mintae Kim et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "딥러닝 기반 DAE 기법을 활용하여 의료 설문 결측 데이터를 복원하는 방법을 제안합니다.",
        keyPoints: [
          "Denoising Auto Encoder(DAE) 기법 활용한 결측치 복원",
          "GMD(Generation Missing Data)와 RMD(Restore Missing Data) 방법 적용",
          "PCS 2015 설문 데이터 사용 (개인정보, 질병정보, 보험정보 등)",
          "결측 데이터로 인한 학습 데이터 손실 방지"
        ],
        methodology: "통계적 방법(평균/중간값)으로 예측 후 DAE를 적용하여 원본 데이터와 학습 모델 생성",
        results: "결측 40% 환경에서 DNN 38% → DAE+DNN 55~58%로 10~18% 정확도 개선",
        pdfFile: "딥러닝 기반 의료 설문 결측 데이터 보간.pdf"
      },
      {
        id: 5,
        title: "임베디드 환경에서 딥러닝 기반 디지털 헬스케어 시스템의 성능 비교",
        titleEn: "Performance Comparison of Deep Learning-Based Digital Healthcare Systems in Embedded Environments",
        year: 2023,
        authors: "NaHyun Woo, GeonSoo Jang, YunJu Oh, Subhin Yang, Mintai Kim et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "질병 예방 및 건강 관리를 위한 딥러닝 기반 헬스케어 자가 진단 서비스를 임베디드 시스템에 구축하고 성능을 비교합니다.",
        keyPoints: [
          "얼굴 비대칭, 어깨 비대칭, 보행 패턴 분석 기능 구현",
          "Jetson TX2 NX Module vs Raspberry Pi 4 성능 비교",
          "Realsense D435 카메라와 MediaPipe Holistic 모델 사용",
          "스켈레톤 추출 및 각도 분석을 통한 비대칭 진단"
        ],
        methodology: "Vision AI 프레임워크(MediaPipe)로 스켈레톤 추출 후 각도 분석하여 비대칭 정도 및 보행 패턴 도출",
        results: "Jetson TX2 NX가 Raspberry Pi 4 대비 얼굴(약 6초), 어깨(약 25초), 보행(약 15초) 더 빠른 수행 속도",
        pdfFile: "임베디드 환경에서 딥러닝 기반 디지털 헬스케어 시스템의 성능 비교  Jetson TX2 N.pdf"
      }
    ]
  },
  {
    id: 2,
    title: "Clinical NLP & Language Systems",
    titleKo: "임상 NLP 및 언어 시스템",
    description: "Natural language processing for clinical trial eligibility and rule-based service systems",
    descriptionKo: "임상시험 적격성 판단을 위한 자연어 처리 및 규칙 기반 서비스 시스템",
    icon: "🗣️",
    color: "from-purple-500 to-pink-500",
    bgGradient: "from-purple-50 to-pink-50",
    papers: [
      {
        id: 6,
        title: "임상시험 참여의 적격성 판독을 위한 NLP 기반 전문가 시스템",
        titleEn: "NLP-Based Expert System for Clinical Trial Eligibility Assessment",
        year: 2022,
        authors: "Su-Bhin Yang, Mintai Kim et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "임상시험 대상자의 적격성 판독 과정에서 발생하는 수동적 작업을 자동화하는 NLP 기반 전문가 시스템을 제안합니다.",
        keyPoints: [
          "BERT 모델을 사용하여 전문가 시스템 규칙 생성",
          "임상시험 대상자 정보와 규칙 비교를 통한 적격성 판독",
          "Human error 및 시간/비용 소모 감소",
          "성별 환경(남자/여자 참여) 질의 실험"
        ],
        methodology: "BERT를 통해 생성된 규칙과 임상시험 대상자 정보의 비교 연산을 통한 적격성 판독",
        results: "BERT 생성 규칙이 실제 규정과 일치하는 정확도 평균 99.03%",
        pdfFile: "임상시험 참여의 적격성 판독을 위한 NLP 기반 전문가 시스템 (1).pdf"
      },
      {
        id: 7,
        title: "질병 이력의 자연어 분석 기반 임상시험 참여 자격요건 판단",
        titleEn: "Clinical Trial Eligibility Determination Based on Natural Language Analysis of Medical History",
        year: 2022,
        authors: "Nahyun Woo, Mintai Kim et al",
        journal: "한국통신학회 학술대회논문집",
        summary: "임상시험 자격요건의 질병 이력에 대한 적격성을 효과적으로 판독하기 위해 BERT를 활용한 자연어 분석 기반 판독법을 제안합니다.",
        keyPoints: [
          "포함 조건(Inclusion)과 배제 조건(Exclusion)을 별도 BERT로 처리",
          "두 특징 벡터를 합쳐 MLP로 분류 (무관/포함/배제)",
          "2020년 Clinicaltrials.gov 상위 5개 질병 기준 실험",
          "천식, 고혈압, 제2형 당뇨병, COVID-19, HIV 데이터"
        ],
        methodology: "Inclusion/Exclusion을 각각 다른 BERT로 특징 추출 후 MLP로 질병 이력 자격요건 분류",
        results: "예측 정확도 96.02%(제2형 당뇨병) ~ 99.02%(HIV) 달성",
        pdfFile: "질병 이력의 자연어 분석 기반 임상시험 참여 자격요건 판단.pdf"
      },
      {
        id: 8,
        title: "드라이브 스루 환경에서 규칙 기반 무인 커피 주문 시스템",
        titleEn: "Rule-Based Unmanned Coffee Ordering System in Drive-Through Environment",
        year: 2024,
        authors: "Su-Bhin Yang, Mintai Kim et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "LLM의 높은 계산/네트워크 비용 문제를 해결하기 위해 제한된 언어 환경에 적합한 규칙 기반 시스템을 제안합니다.",
        keyPoints: [
          "지식 베이스와 추론 기관으로 구성된 전문가 시스템",
          "순방향 추론(Forward Chaining) 방법 사용",
          "주문 추론 및 누락 정보 보완",
          "LLM 대비 유사한 정확도와 획기적인 속도 개선"
        ],
        methodology: "전문가 시스템의 순방향 추론을 통해 주문을 추론하고 누락된 정보 보완",
        results: "규칙 기반 98.7% vs LLM 97.5% 정확도, 처리 속도 약 7천 배 개선 (1.06×10⁻⁴초 vs 1.35초)",
        pdfFile: "드라이브 스루 환경에서 규칙 기반 무인 커피 주문 시스템.pdf"
      },
      {
        id: 9,
        title: "빠른 응답을 위한 규칙 기반 무인 커피 음성 주문 시스템",
        titleEn: "Rule-Based Unmanned Coffee Voice Ordering System for Fast Response",
        year: 2025,
        authors: "Su-Bhin Yang, Mintai Kim et al",
        journal: "Korean Institute of Information Scientists and Engineers (KCI)",
        summary: "드라이브 스루 환경에서 빠른 응답을 제공하기 위한 규칙 기반 음성 주문 시스템을 제안합니다.",
        keyPoints: [
          "540가지 조합의 제한된 언어 환경 기반",
          "음절 단위 분석과 LCS 알고리즘을 이용한 유사 메뉴 추천",
          "6가지 ASR 모델 성능 비교 및 최적화",
          "Google Recognition Speech 모델 선정 (0.97초, CER 0.15)"
        ],
        methodology: "음절 단위 분석과 최장 공통 부분 수열(LCS) 알고리즘으로 유사 메뉴 추론",
        results: "규칙 기반 98% vs LLM 93.2% 정확도, 처리 속도 최대 약 5만 배 개선 (6.79×10⁻⁵초 vs 1.70초), CER 76.19% 개선",
        pdfFile: "빠른 응답을 위한 규칙 기반 무인 커피 음성 주문 시스템.pdf"
      }
    ]
  },
  {
    id: 3,
    title: "Industrial & Acoustic AI Systems",
    titleKo: "산업 음향 및 음향 AI 시스템",
    description: "AI-based abnormal voltage diagnosis and noise robustness in transformer acoustic analysis",
    descriptionKo: "변압기 음향 분석을 통한 AI 기반 이상 전압 진단 및 잡음 강건성",
    icon: "🔊",
    color: "from-orange-500 to-red-500",
    bgGradient: "from-orange-50 to-red-50",
    papers: [
      {
        id: 10,
        title: "소리 정보를 이용한 배전용 변압기의 이상 전압 탐지",
        titleEn: "Abnormal Voltage Detection of Distribution Transformers Using Sound Information",
        year: 2020,
        authors: "Mintai Kim, Seonmin Lee et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "전력 변압기의 이상 전압으로 인한 사고를 사전에 방지하기 위해 음향 신호를 분석하여 이상 전압을 탐지하는 기술을 제안합니다.",
        keyPoints: [
          "정상(100%), 저전압(95%), 과전압(105%) 변압기 소리 비교",
          "Spectrum Centroids와 Spectral Roll-Off 특징 추출",
          "SVM을 이용한 비정상 전압 분류",
          "95% 정확도로 비정상 전압 탐지"
        ],
        methodology: "소리 분석을 위한 특징 벡터(Spectrum Centroids, Spectral Roll-Off) 추출 후 SVM 분류",
        results: "95% 정확도로 비정상적인 전압 탐지 성공",
        pdfFile: "소리 정보를 이용한 배전용 변압기의 이상 전압 탐지.pdf"
      },
      {
        id: 11,
        title: "U-net 기반 멜-스펙트로그램을 이용한 배전용 변압기의 배경 소리 제거",
        titleEn: "Background Noise Removal for Distribution Transformers Using U-Net-Based Mel-Spectrograms",
        year: 2021,
        authors: "Mintai Kim, Seonmin Lee et al",
        journal: "한국정보과학회 학술발표논문집",
        summary: "변압기 이상 상황 탐지 시 배경 소리가 탐지에 미치는 영향을 제거하기 위해 U-Net 기반 멜-스펙트로그램을 이용한 배경 소리 제거 방법을 제안합니다.",
        keyPoints: [
          "인간 청각 기관을 모사한 멜-스펙트로그램 특징 추출",
          "음악 음원 분리 원리를 활용한 U-Net 구조",
          "Encoder-Decoder 구조와 Skip Connection",
          "SNR 0 환경에서 MSE 98%, MAE 74% 감소"
        ],
        methodology: "멜-스펙트로그램으로 전처리 후 U-Net 기반 딥러닝으로 음원 분리",
        results: "배경 소리가 큰 환경(SNR 0)에서 MSE 98%, MAE 74% 감소로 배경 소리 성공적 제거",
        pdfFile: "U-net 기반 멜-스펙트로그램을 이용한 배전용 변압기의 배경 소리 제거.pdf"
      },
      {
        id: 12,
        title: "Noise-Robust Deep Learning Model for Abnormal Voltage State Classification of Transformers Using Acoustic Signals",
        titleEn: "Noise-Robust Deep Learning Model for Abnormal Voltage State Classification (SCI)",
        year: 2022,
        authors: "Mintai Kim, Sungju. Lee",
        journal: "MDPI Sensors (SCI)",
        summary: "변압기 음향 신호를 사용하여 과전압, 정상전압, 저전압을 분류하며, 알려진/알려지지 않은 잡음 환경 모두에 강건한 딥러닝 모델을 제안합니다.",
        keyPoints: [
          "멜 스펙트로그램(MS)으로 음향 신호 변환",
          "U-Net 인코더 기반 분류 모델 설계",
          "알려진 잡음: U-Net 기반 잡음 제거",
          "알려지지 않은 잡음: Bagging 앙상블 모델 (Model A/B/C)"
        ],
        methodology: "멜 스펙트로그램 + U-Net 인코더 + 잡음 제거 + Bagging 앙상블(무잡음/잡음포함/잡음감소 모델)",
        results: "기준 모델 72% → 잡음 제거 88% → 앙상블 94% 정확도 달성, 모델 다양성으로 일반화 성능 향상",
        pdfFile: "sensors-22-01248 (1).pdf",
        doi: "https://doi.org/10.3390/s22031248"
      },
      {
        id: 13,
        title: "잡음에 강한 딥러닝 모델을 적용한 음향 신호 기반 변압기 이상전압 상태 분류",
        titleEn: "Transformer Abnormal Voltage Classification Using Noise-Robust Deep Learning (Master's Thesis)",
        year: 2024,
        authors: "Mintai Kim",
        journal: "Sangmyung University 석사 학위 논문",
        summary: "변압기 음향 신호 기반 전압 수준 분류에서 잡음 강건성을 확보한 딥러닝 모델을 설계하는 석사 학위 논문입니다.",
        keyPoints: [
          "SCI 논문(Sensors 2022)의 확장 연구",
          "알려진 잡음 제거와 알려지지 않은 잡음 대응 전략",
          "U-Net 기반 잡음 제거 + Bagging 앙상블",
          "다양한 잡음 환경에서 강건한 분류 성능"
        ],
        methodology: "멜 스펙트로그램 기반 U-Net 인코더 + 잡음 제거 + Bagging 앙상블 모델",
        results: "다양한 잡음 환경에서 94% 정확도 달성, 앙상블을 통한 일반화 성능 향상",
        pdfFile: "잡음에_강한_딥러닝_모델을_적용한_음향_신호를_이용한_변압기의_이상전압_상태_분류.pdf",
        link: "https://dl.nanet.go.kr/search/searchInnerDetail.do?searchType=INNER_SEARCH&resultType=INNER_SEARCH_DETAIL&searchMehtod=L&searchClass=S&controlNo=KDMT12025000007089"
      }
    ]
  },
  {
    id: 4,
    title: "Time Series & Real-Time AI Systems",
    titleKo: "시계열 및 실시간 AI 시스템",
    description: "Time series forecasting and ensemble learning for power generation and natural ventilation prediction",
    descriptionKo: "발전량 및 자연환기량 예측을 위한 시계열 예측 및 앙상블 학습",
    icon: "📈",
    color: "from-green-500 to-teal-500",
    bgGradient: "from-green-50 to-teal-50",
    papers: [
      {
        id: 14,
        title: "Prediction of Power Generation by Ensemble and Transfer Learning Based on Machine Learning",
        titleEn: "Power Generation Prediction Using Ensemble and Transfer Learning",
        year: 2022,
        authors: "Mintai Kim et al",
        journal: "2022 POSTECH X DERShare OIBC 태양광 발전량 예측 경진대회 (Competition Award)",
        summary: "기상 예측 데이터를 활용하여 태양광 발전소의 미래 발전량을 예측하는 앙상블 및 전이 학습 기반 모델을 제안합니다. 경진대회 수상작입니다.",
        keyPoints: [
          "3가지 기상 예측 데이터에 대해 LSTM 3개 + DNN 3개 모델 생성",
          "DNN-LSTM 앙상블 모델로 지식 융합",
          "전이 학습으로 학습 데이터 확장",
          "발전소별 규모 차이를 정규화로 해소",
          "POSTECH X DERShare OIBC 경진대회 수상"
        ],
        methodology: "앙상블 모델로 성능 개선 후 전이 학습으로 타 발전소 데이터 활용하여 예측 정확도 향상",
        results: "앙상블과 전이 학습을 통해 예측 정확도 개선 확인, 경진대회에서 우수한 성과 달성",
        pdfFile: null
      },
      {
        id: 15,
        title: "Time Series Prediction Methodology and Ensemble Model Using Real-World Data",
        titleEn: "Time Series Prediction Using Ensemble Model with Real-World Data (SCI)",
        year: 2023,
        authors: "Mintai Kim, Sungju. Lee, Taikyeong Jeong",
        journal: "MDPI Electronics (SCI)",
        summary: "실제 상업용 냉장고의 전력 소비 데이터를 기반으로 시계열 예측 방법과 앙상블 기법을 통해 전력 예측 정확도를 개선합니다.",
        keyPoints: [
          "계절성 및 주기성 분석으로 주중/토요일/일요일 클래스 분리",
          "피크 스팟 과도 탐지 방지",
          "RNN, LSTM, GRU 스태킹 앙상블",
          "98.43% 정확도 달성"
        ],
        methodology: "전력 사용 패턴을 요일별 클래스로 분리하고 RNN/LSTM/GRU 스태킹 앙상블 적용",
        results: "앙상블 모델 98.43% vs 단일 모델 최고(LSTM) 96.9%, 클래스 분리 시 LSTM 95.23% 대비 3.2% 개선",
        pdfFile: "electronics-12-02811-v3 (1).pdf",
        doi: "https://doi.org/10.3390/electronics12132811"
      },
      {
        id: 16,
        title: "Deep-Learning-Based Natural Ventilation Rate Prediction with Auxiliary Data in Mismeasurement Sensing Environments",
        titleEn: "NVR Prediction with Auxiliary Data in Mismeasurement Environments (SCI)",
        year: 2023,
        authors: "Subhin Yang, Mintai Kim, Sungju Lee",
        journal: "MDPI Electronics (SCI)",
        summary: "센서 오작동으로 인한 부정확한 데이터 환경에서 건물 자연환기량(NVR) 예측 정확도를 개선하는 딥러닝 기반 방법을 제안합니다.",
        keyPoints: [
          "준지도학습(SSL) 기반 보조 데이터 생성",
          "주기성 특징은 LSTM, 비주기성 특징은 DNN 사용",
          "NVR 중요 특징(Pd, Wd, Ws, Td) 활용",
          "Bagging 앙상블 모델로 일반화 성능 향상"
        ],
        methodology: "준지도학습으로 보조 데이터 생성 후 관측/보조/중요특징 통합하여 Bagging 앙상블 학습",
        results: "오측정 환경(결측 30%)에서 기준 모델 대비 최대 29%p NVR 예측 정확도 개선",
        pdfFile: "electronics-12-03294 (1).pdf",
        doi: "https://doi.org/10.3390/electronics12153294"
      },
      {
        id: 17,
        title: "Augmenting Knowledge for Individual NVR Prediction in Different Spatial and Temporal Cross-Building Environments",
        titleEn: "NVR Prediction in Cross-Building Environments Using Knowledge Augmentation (SCI)",
        year: 2024,
        authors: "Mintai Kim, Sungju. Lee",
        journal: "MDPI Electronics (SCI)",
        summary: "학습 데이터가 부족한 환경에서 서로 다른 공간 및 계절 환경의 지식을 공유하여 개별 건물의 NVR 예측 정확도를 높이는 방법을 제안합니다.",
        keyPoints: [
          "데이터 정규화로 공간적/시간적 차이 해소",
          "전이 학습 레이어 선택 (상위 2개 레이어 고정)",
          "Bagging 앙상블로 강건성 향상",
          "다른 건물 및 계절 데이터 활용"
        ],
        methodology: "Source 데이터를 Target 데이터 분포에 정규화 후 전이 학습 레이어 최적화 및 Bagging 앙상블 적용",
        results: "다른 사무실 및 계절 환경에서 NVR 예측 정확도 최대 11.8% 개선, 앙상블로 단일 모델 불안정성 극복",
        pdfFile: "electronics-13-02901 (1).pdf",
        doi: "https://doi.org/10.3390/electronics13152901"
      }
    ]
  }
];
